/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// console.log('It\'s working!')

var body = document.body;
var html = document.documentElement;

var mainNavigation = document.getElementById('header');
var mainNavigationElements = mainNavigation.getElementsByClassName('main-navigation');
var currentTarget = body.classList[0];
var currentTime = html.matches('.day') ? 'day' : 'night';
var splashscreenIteration = 3;
// console.log(html.classList)

// polyfill

if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
		var matches = (this.document || this.ownerDocument).querySelectorAll(s),
		    i = matches.length;
		while (--i >= 0 && matches.item(i) !== this) {}
		return i > -1;
	};
}

// helper functions

function hasClass(ele, cls) {
	return ele.getAttribute('class').indexOf(cls) > -1;
}

function addClass(ele, cls) {
	if (ele.classList) {
		ele.classList.add(cls);
	} else if (!hasClass(ele, cls)) {
		ele.setAttribute('class', ele.getAttribute('class') + ' ' + cls);
	}
}

function removeClass(ele, cls) {
	if (ele.classList) {
		ele.classList.remove(cls);
	} else if (hasClass(ele, cls)) {
		ele.setAttribute('class', ele.getAttribute('class').replace(cls, ' '));
	}
}

function removeAllClasses(ele) {
	if (ele.classList) {
		var cl = ele.classList;
		for (var i = cl.length; i > 0; i--) {
			cl.remove(cl[0]);
		}
	}
}

function addEventListener(obj, evt, func) {
	if ('addEventListener' in window) {
		obj.addEventListener(evt, func, false);
	} else if ('attachEvent' in window) {
		//IE
		obj.attachEvent('on' + evt, func);
	}
}

if (typeof Storage !== "undefined") {
	if (!sessionStorage.getItem('splashShown') || sessionStorage.getItem('splashShown') === null) {
		sessionStorage.setItem('splashShown', true);
	} else {
		splashscreenIteration = 1;
	}
}

function splashscreen(iterationCount) {
	currentTime = html.matches('.day') ? 'day' : 'night';
	//	console.log(currentTime)
	//	if (html.matches('.day')) {
	//		console.log('true:  ' + html.matches('.day'))
	//	} else {
	//		console.log('false: ' + html.matches('.day'))
	//	}
	for (var i = 1; i <= iterationCount; i++) {
		setTimeout(setTime, i * 1200);
	}
	setTimeout(function () {
		var splashscreen = document.getElementById('splashscreen').style.display = 'none';
	}, iterationCount * 1200);
}

function setTime() {
	//	console.log('check')
	//	console.log('currentTime: ' + currentTime)
	html.classList.remove(currentTime);
	//		console.log('removed: ' + currentTime)
	currentTime = currentTime === 'day' ? 'night' : 'day';
	html.classList.add(currentTime);
	//		console.log('added:   ' + currentTime)
}

function mainNavigationElementClickHandler(e) {
	e.preventDefault();

	var that = this;
	if (this.matches('.active')) {
		that = mainNavigationElements[0];
	}
	var target = that.dataset.target;
	var href = that.href;

	console.log('target: ' + target);
	console.log(currentTarget);
	if (target === 'dates' && currentTarget === 'dates') {
		target = 'amenthia-nights';
		//		currentTarget = 'amenthia-nights'
		//		history.pushState(target, null, href)
		//		history.pushState(target, null, href)
		removeAllClasses(body);
		addClass(body, target);
		for (var i = 1; i < mainNavigationElements.length; i++) {
			removeClass(mainNavigationElements[i], 'active');
			addClass(mainNavigationElements[i], 'hidden');
		}
		addClass(that, 'active');
	} else if (currentTarget !== target) {
		removeAllClasses(body);
		addClass(body, target);
		for (var i = 1; i < mainNavigationElements.length; i++) {
			removeClass(mainNavigationElements[i], 'active');
			removeClass(mainNavigationElements[i], 'hidden');
		}
		history.pushState(target, null, href);
		addClass(that, 'active');
	}

	currentTarget = target;
}

for (var i = 0; i < mainNavigationElements.length; i++) {
	mainNavigationElements[i].addEventListener('click', mainNavigationElementClickHandler);
}
window.addEventListener('popstate', function (e) {
	var target = e.state;
	var currMainNavigationElement = mainNavigation.querySelector('a[data-target="' + target + '"]');
	for (var i = 0; i < mainNavigationElements.length; i++) {
		removeClass(mainNavigationElements[i], 'active');
	}
	addClass(currMainNavigationElement, 'active');
	if (target == null) {
		removeAllClasses(body);
		addClass(body, 'dates');
	} else {
		removeAllClasses(body);
		addClass(body, target);
	}
});

document.onkeydown = function (e) {
	//	console.log(e.keyCode)
	switch (e.keyCode) {
		case 68:
			removeClass(html, 'night');
			addClass(html, 'day');
			break;
		case 78:
			removeClass(html, 'day');
			addClass(html, 'night');
			break;
	}
};

splashscreen(splashscreenIteration);
document.addEventListener("touchstart", function () {}, true);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// assets/bundle.js